"use strict";
import { MSNumericUpDown } from '../controls/numericupdown/numericupdown.js'
import { MSCheckBox } from '../controls/checkbox/checkbox.js'
import { MSColorPicker } from '../controls/colorpicker/colorpicker.js'
import { MSDateTimePicker } from '../controls/dtpicker/dtpicker.js';
import { MSInterval } from '../controls/interval/interval.js';
import { MSPopUpWindow } from '../controls/popup_window/popup_window.js';
import i18next from "i18next";

export class Inputs {
    constructor(el) {
        this._main = el;
        if (typeof window.customElements.get('ms-numericupdown') === 'undefined') {
            window.customElements.define('ms-numericupdown', MSNumericUpDown);
        }
        if (typeof window.customElements.get('ms-colorpicker') === 'undefined') {
            window.customElements.define('ms-colorpicker', MSColorPicker);
        }
        if (typeof window.customElements.get('ms-dtpicker') === 'undefined') {
            window.customElements.define('ms-dtpicker', MSDateTimePicker);
        }
        if (typeof window.customElements.get('ms-interval') === 'undefined') {
            window.customElements.define('ms-interval', MSInterval);
        }
        if (typeof window.customElements.get('ms-checkbox') === 'undefined') {
            window.customElements.define('ms-checkbox', MSCheckBox);
        }
        this._btnBlock = `<div class="Login" style="display: flex; margin: 5px; justify-content: flex-end;">
        <button class="ack" style="padding: 2px 10px; margin-right:5px" id="btnOk">${i18next.t('apply')}</button>
        <button class="ack" style="padding: 2px 10px;" id="btnCancel">${i18next.t('cancel')}</button>
        </div>`;
        this.global = this.global.bind(this);
    }


    global(ev) {
        switch (ev.keyCode) {
            case 27: //Esc
                this.btnCancel.onclick(ev);
                break;
            case 13: // Enter
                this.btnOk.onclick(ev);
                break;
            default:
                break;
        }
    }
    inputBoxIntervalRange(e, title, value, opt, callback, options) {
        let box;
        if (!options) {
            options = { toBody: false, alignToElement: false }
        } else if (options.alignToElement) {
            box = options.element.getBoundingClientRect();
        }
        this.options = options;
        if (e && e.preventDefault) e.preventDefault();
        if (!this._PopupDiv) {
            if (!opt) {
                opt = {
                    timeformat: 'dd.HH:mm:ss'
                }
            } else {
                if (!opt.timeformat) opt.timeformat = 'dd.HH:mm:ss';
            }
            this.createPopup();
            if (options.zIndex) this._back.style.zIndex = options.zIndex;
            this._PopupDiv.innerHTML = `
                <label style="font-size: 80%;">${title}</label>
                <div class="inp"><ms-interval utc="true" id="inp1" allownull="true" backgroundcolor="" timeformat="${opt.timeformat}" style="width:180px;border:1px solid;"></ms-interval><div id="clear1" class="bgimg hmi-j-close"></div></div>
                <div class="inp"><ms-interval utc="true" id="inp2" allownull="true" backgroundcolor="" timeformat="${opt.timeformat}" style="width:180px;border:1px solid;"></ms-interval><div id="clear2" class="bgimg hmi-j-close"></div></div>
                ${this._btnBlock}
            `;
            const input1 = this._PopupDiv.querySelector('ms-interval#inp1');
            const input2 = this._PopupDiv.querySelector('ms-interval#inp2');
            input1.datetime = value.min;
            input1.style.position = 'relative';
            input2.datetime = value.max;
            input2.style.position = 'relative';
            this.btnOk = this._PopupDiv.querySelector('#btnOk');
            this.btnCancel = this._PopupDiv.querySelector('#btnCancel');

            const btnClear1 = this._PopupDiv.querySelector('#clear1');
            const btnClear2 = this._PopupDiv.querySelector('#clear2');

            btnClear1.onclick = e => {
                e.preventDefault();
                input1.datetime = 0;
            }

            btnClear2.onclick = e => {
                e.preventDefault();
                input2.datetime = 0;
            }

            document.addEventListener('keydown', this.global, false);

            if (options.showFocus) {
                this._oldBorder = options.element.style.border;
                options.element.style.border = 'blue 1px solid';
            }

            this.btnOk.onclick = (event) => {
                if (event) event.stopPropagation();
                document.removeEventListener('keydown', global, false);
                if (callback) {
                    const ret = {};
                    if (typeof input1.datetime === 'number') { ret['min'] = input1.datetime; }
                    if (typeof input2.datetime === 'number') { ret['max'] = input2.datetime; }
                    callback(ret);
                }
                this.close();
            };

            this.btnCancel.onclick = this._back.onclick = (event) => {
                this._cancel(event);
            };

            this._back.appendChild(this._PopupDiv);
            if (options.toBody) {
                this._main = document.body.appendChild(this._back);
            } else {
                this._main.appendChild(this._back);
                if (box) {
                    const boxShift = this._back.getBoundingClientRect();
                    box = {
                        left: box.left - boxShift.left,
                        top: box.top - boxShift.top,
                        height: box.height,
                        width: box.width,
                        bottom: box.bottom - boxShift.top
                    }
                }
            }


            input1.focus();
        }

        this._Show(box);
    }

    inputBoxDataRange(e, title, value, opt, callback, options) {
        let box;
        if (!options) {
            options = { toBody: false, alignToElement: false }
        } else if (options.alignToElement) {
            box = options.element.getBoundingClientRect();
        }
        this.options = options;
        if (e && e.preventDefault) e.preventDefault();
        if (!this._PopupDiv) {
            if (!opt) {
                opt = {
                    datetimetype: 1,
                    timeformat: 'HH:mm:ss',
                    dateformat: 'dd.MM.yyyy',
                    utc: true
                }
            } else {
                if (!opt.timeformat) opt.timeformat = 'HH:mm:ss';
                if (!opt.dateformat) opt.dateformat = 'dd.MM.yyyy';
            }
            this.createPopup();
            if (options.zIndex) this._back.style.zIndex = options.zIndex;
            this._PopupDiv.innerHTML = `
                <label style="font-size: 80%;">${title}</label>
                <div class="inp"><ms-dtpicker utc="true" id="inp1" isreadonly="false" backgroundcolor="" allownull="true" datetimetype="${opt.datetimetype}" timeformat="${opt.timeformat}" dateformat="${opt.dateformat}" style="width:180px;border:1px solid;"></ms-dtpicker><div id="clear1" class="bgimg hmi-j-close"></div></div>
                <div class="inp"><ms-dtpicker utc="true" id="inp2" isreadonly="false" backgroundcolor="" allownull="true" datetimetype="${opt.datetimetype}" timeformat="${opt.timeformat}" dateformat="${opt.dateformat}" style="width:180px;border:1px solid;"></ms-dtpicker><div id="clear2" class="bgimg hmi-j-close"></div></div>
                ${this._btnBlock}
            `;
            const input1 = this._PopupDiv.querySelector('ms-dtpicker#inp1');
            const input2 = this._PopupDiv.querySelector('ms-dtpicker#inp2');
            input1.datetime = value.min;
            input1.style.position = 'relative';
            input2.datetime = value.max;
            input2.style.position = 'relative';
            this.btnOk = this._PopupDiv.querySelector('#btnOk');
            this.btnCancel = this._PopupDiv.querySelector('#btnCancel');

            const btnClear1 = this._PopupDiv.querySelector('#clear1');
            const btnClear2 = this._PopupDiv.querySelector('#clear2');

            btnClear1.onclick = e => {
                e.preventDefault();
                input1.datetime = undefined;
            }

            btnClear2.onclick = e => {
                e.preventDefault();
                input2.datetime = undefined;
            }

            document.addEventListener('keydown', this.global, false);

            if (options.showFocus) {
                this._oldBorder = options.element.style.border;
                options.element.style.border = 'blue 1px solid';
            }

            this.btnOk.onclick = (event) => {
                if (event) event.stopPropagation();
                document.removeEventListener('keydown', this.global, false);
                if (callback) {
                    const ret = {};
                    if (typeof input1.datetime === 'number') { ret['min'] = input1.datetime; }
                    if (typeof input2.datetime === 'number') { ret['max'] = input2.datetime; }
                    callback(ret);
                }
                this.close();
            };

            this.btnCancel.onclick = this._back.onclick = (event) => {
                this._cancel(event);
            };

            this._back.appendChild(this._PopupDiv);
            if (options.toBody) {
                this._main = document.body.appendChild(this._back);
            } else {
                this._main.appendChild(this._back);
                if (box) {
                    const boxShift = this._back.getBoundingClientRect();
                    box = {
                        left: box.left - boxShift.left,
                        top: box.top - boxShift.top,
                        height: box.height,
                        width: box.width,
                        bottom: box.bottom - boxShift.top
                    }
                }
            }

            input1.focus();
        }

        this._Show(box);
    }
    inputBoxNumberRange(e, title, value, callback, options) {
        let box;
        if (!options) {
            options = { toBody: false, alignToElement: false }
        } else if (options.alignToElement) {
            box = options.element.getBoundingClientRect();
        }
        this.options = options;
        const min = options.min ? ` minvalue="${options.min}"` : '';
        const max = options.max ? ` maxvalue="${options.max}"` : '';

        if (e && e.preventDefault) e.preventDefault();
        if (!this._PopupDiv) {
            this.createPopup();
            if (options.zIndex) this._back.style.zIndex = options.zIndex;
            this._PopupDiv.innerHTML = `
                <label style="font-size: 80%;">${title}</label>
                <div class="inp"><ms-numericupdown${min}${max} allownull="true" id="inp1" backgroundcolor="" style="width:180px;border:1px solid;"></ms-numericupdown><div id="clear1" class="bgimg hmi-j-close"></div></div>
                <div class="inp"><ms-numericupdown${min}${max} allownull="true" id="inp2" backgroundcolor="" style="width:180px;border:1px solid;"></ms-numericupdown><div id="clear2" class="bgimg hmi-j-close"></div></div>
                ${this._btnBlock}
            `;
            const input1 = this._PopupDiv.querySelector('ms-numericupdown#inp1');
            const input2 = this._PopupDiv.querySelector('ms-numericupdown#inp2');
            input1.incrementstep = '1.0';
            input1.value = value.min;
            input1.style.position = 'relative';
            input2.incrementstep = '1.0';
            input2.value = value.max;
            input2.style.position = 'relative';
            this.btnOk = this._PopupDiv.querySelector('#btnOk');
            this.btnCancel = this._PopupDiv.querySelector('#btnCancel');

            const btnClear1 = this._PopupDiv.querySelector('#clear1');
            const btnClear2 = this._PopupDiv.querySelector('#clear2');

            btnClear1.onclick = e => {
                e.preventDefault();
                input1.value = null;
            }

            btnClear2.onclick = e => {
                e.preventDefault();
                input2.value = null;
            }

            document.addEventListener('keydown', this.global, false);

            if (options.showFocus) {
                this._oldBorder = options.element.style.border;
                options.element.style.border = 'blue 1px solid';
            }

            this.btnOk.onclick = (event) => {
                if (event) event.stopPropagation();
                document.removeEventListener('keydown', this.global, false);
                if (callback) {
                    callback({ min: input1.value, max: input2.value });
                }
                this.close();
            };

            this.btnCancel.onclick = this._back.onclick = (event) => {
                this._cancel(event);
            };

            this._back.appendChild(this._PopupDiv);
            if (options.toBody) {
                this._main = document.body.appendChild(this._back);
            } else {
                this._main.appendChild(this._back);
                if (box) {
                    const boxShift = this._back.getBoundingClientRect();
                    box = {
                        left: box.left - boxShift.left,
                        top: box.top - boxShift.top,
                        height: box.height,
                        width: box.width,
                        bottom: box.bottom - boxShift.top
                    }
                }
            }

            input1.focus(box);
        }

        this._Show(box);
    }
    inputBoxData(e, title, value, callback, options) {
        let box;
        if (!options) {
            options = { toBody: false, alignToElement: false }
        } else if (options.alignToElement) {
            box = options.element.getBoundingClientRect();
        }
        this.options = options;
        if (e && e.preventDefault) e.preventDefault();
        if (!this._PopupDiv) {
            this.createPopup();
            if (options.zIndex) this._back.style.zIndex = options.zIndex;
            this._PopupDiv.innerHTML = `
                <label style="font-size: 80%;">${title}</label>
                <ms-dtpicker utc="true" datetimetype="1" size="40" isreadonly="false" style="width: 180px; border: 1px solid;"></ms-dtpicker>
                ${this._btnBlock}
            `;
            const input = this._PopupDiv.querySelector('ms-dtpicker');
            input.timeformat = 'HH:mm';
            input.dateformat = 'dd.MM.yyyy';
            input.datetime = value;
            input.style.position = 'relative';
            this.btnOk = this._PopupDiv.querySelector('#btnOk');
            this.btnCancel = this._PopupDiv.querySelector('#btnCancel');

            document.addEventListener('keydown', this.global, false);

            if (options.showFocus) {
                this._oldBorder = options.element.style.border;
                options.element.style.border = 'blue 1px solid';
            }

            this.btnOk.onclick = (event) => {
                if (event) event.stopPropagation();
                document.removeEventListener('keydown', this.global, false);
                if (callback) {
                    callback(input.datetime);
                }
                this.close();
            };

            this.btnCancel.onclick = this._back.onclick = (event) => {
                this._cancel(event);
            };

            this._back.appendChild(this._PopupDiv);
            if (options.toBody) {
                this._main = document.body.appendChild(this._back);
            } else {
                this._main.appendChild(this._back);
                if (box) {
                    const boxShift = this._back.getBoundingClientRect();
                    box = {
                        left: box.left - boxShift.left,
                        top: box.top - boxShift.top,
                        height: box.height,
                        width: box.width,
                        bottom: box.bottom - boxShift.top
                    }
                }
            }

            input.focus();
        }

        this._Show(box);
    }
    inputBoxText(e, title, value, callback, options) {
        let box;
        if (!options) {
            options = { toBody: false, alignToElement: false }
        } else if (options.alignToElement) {
            box = options.element.getBoundingClientRect();
        }
        this.options = options;
        if (e && e.preventDefault) e.preventDefault();
        if (!this._PopupDiv) {
            this.createPopup();
            if (options.zIndex) this._back.style.zIndex = options.zIndex;
            this._PopupDiv.innerHTML = `
                <label style="font-size: 80%;">${title}</label>
                <div class="inp"><input type="text" id="inp" size="40" style="width: 180px; border: 1px solid;"><div id="clear1" class="bgimg hmi-j-close"></div></div>
                ${this._btnBlock}
            `;
            const input = this._PopupDiv.querySelector('input');
            input.value = value;
            input.style.position = 'relative';
            this.btnOk = this._PopupDiv.querySelector('#btnOk');
            this.btnCancel = this._PopupDiv.querySelector('#btnCancel');
            const btnClear = this._PopupDiv.querySelector('#clear1');

            document.addEventListener('keydown', this.global, false);

            if (options.showFocus) {
                this._oldBorder = options.element.style.border;
                options.element.style.border = 'blue 1px solid';
            }

            btnClear.onclick = e => {
                e.preventDefault();
                input.value = null;
            }

            this.btnOk.onclick = (event) => {
                if (event) event.stopPropagation();
                document.removeEventListener('keydown', this.global, false);
                if (callback) {
                    callback(input.value);
                }
                this.close();
            };

            this.btnCancel.onclick = this._back.onclick = (event) => {
                this._cancel(event);
            };

            /*
            this._back.onmousedown = (event) => {
                this._cancel(event);
            };*/

            this._back.appendChild(this._PopupDiv);
            if (options.toBody) {
                this._main = document.body.appendChild(this._back);
            } else {
                this._main.appendChild(this._back);
                if (box) {
                    const boxShift = this._back.getBoundingClientRect();
                    box = {
                        left: box.left - boxShift.left,
                        top: box.top - boxShift.top,
                        height: box.height,
                        width: box.width,
                        bottom: box.bottom - boxShift.top
                    }
                }
            }

            input.focus();
        }

        this._Show(box);
    }

    inputBoxNumber(e, title, value, callback, options) {
        let box;
        if (!options) {
            options = { toBody: false, alignToElement: false }
        } else if (options.alignToElement) {
            box = options.element.getBoundingClientRect();
        }
        this.options = options;
        const min = options.min ? ` minvalue="${options.min}"` : '';
        const max = options.max ? ` maxvalue="${options.max}"` : '';

        if (e && e.preventDefault) e.preventDefault();
        if (!this._PopupDiv) {
            this.createPopup();
            if (options.zIndex) this._back.style.zIndex = options.zIndex;
            this._PopupDiv.innerHTML = `
                <label style="font-size: 80%;">${title}</label>
                <ms-numericupdown${min}${max} type="number" maxdecimalplaces="${options.maxdecimalplaces}" id="inp" size="40" height="24" width="170" texthorizontalalign="1" style="margin-bottom: 13px;border: 1px solid;"></ms-numericupdown>
                ${this._btnBlock}
            `;
            const input = this._PopupDiv.querySelector('ms-numericupdown');
            input.incrementstep = '1.0';
            input.value = value;
            input.style.position = 'relative';
            this.btnOk = this._PopupDiv.querySelector('#btnOk');
            this.btnCancel = this._PopupDiv.querySelector('#btnCancel');

            document.addEventListener('keydown', this.global, false);
            if (options.showFocus) {
                this._oldBorder = options.element.style.border;
                options.element.style.border = 'blue 1px solid';
            }

            this.btnOk.onclick = (event) => {
                if (event) event.stopPropagation();
                document.removeEventListener('keydown', this.global, false);
                if (callback) {
                    callback(input._text.value);
                }
                this.close();
            };

            this.btnCancel.onclick = this._back.onclick = (event) => {
                this._cancel(event);
            };

            this._back.appendChild(this._PopupDiv);
            if (options.toBody) {
                this._main = document.body.appendChild(this._back);
            } else {
                this._main.appendChild(this._back);
                if (box) {
                    const boxShift = this._back.getBoundingClientRect();
                    box = {
                        left: box.left - boxShift.left,
                        top: box.top - boxShift.top,
                        height: box.height,
                        width: box.width,
                        bottom: box.bottom - boxShift.top
                    }
                }
            }

            input.focus();
        }

        this._Show(box);
    }

    inputBoxEnum(e, title, list, values, opt, callback, options) {
        let box;
        if (!options) {
            options = { toBody: false, alignToElement: false }
        } else if (options.alignToElement) {
            box = options.element.getBoundingClientRect();
        }
        this.options = options;
        if (e && e.preventDefault) e.preventDefault();
        if (!this._PopupDiv) {
            this.createPopup();
            if (options.zIndex) this._back.style.zIndex = options.zIndex;
            let opt = '';
            for (let i = 0; i < list.length; i++) {
                const el = list[i];
                opt += `<label><input type="checkbox" ${values[i] ? 'checked' : ''}>${el}</label>`;
            }
            this._PopupDiv.innerHTML = `
                <label style="font-size: 80%;">${title}</label>
                <div id="form" style="display:flex;flex-direction:column;border:1px black solid;padding:0.5em;overflow:auto;max-height:5em;">${opt}</div>
                ${this._btnBlock}
            `;
            this.btnOk = this._PopupDiv.querySelector('#btnOk');
            this.btnCancel = this._PopupDiv.querySelector('#btnCancel');

            document.addEventListener('keydown', this.global, false);

            if (options.showFocus) {
                this._oldBorder = options.element.style.border;
                options.element.style.border = 'blue 1px solid';
            }

            this.btnOk.onclick = (event) => {
                if (event) event.stopPropagation();
                document.removeEventListener('keydown', this.global, false);

                const m = this._PopupDiv.querySelector('#form');
                const checked = m.querySelectorAll('input');
                const v = [];
                for (let i = 0; i < checked.length; i++) {
                    v.push(checked[i].checked);
                }
                if (callback) {
                    callback(v);
                }
                this.close();
            };

            this.btnCancel.onclick = this._back.onclick = (event) => {
                this._cancel(event);
            };

            this._back.appendChild(this._PopupDiv);
            if (options.toBody) {
                this._main = document.body.appendChild(this._back);
            } else {
                this._main.appendChild(this._back);
                if (box) {
                    const boxShift = this._back.getBoundingClientRect();
                    box = {
                        left: box.left - boxShift.left,
                        top: box.top - boxShift.top,
                        height: box.height,
                        width: box.width,
                        bottom: box.bottom - boxShift.top
                    }
                }
            }
        }

        this._Show(box);
    }

    inputBoxSelect(e, title, list, value, callback, options) {
        let box;
        if (!options) {
            options = { toBody: false, alignToElement: false }
        } else if (options.alignToElement) {
            box = options.element.getBoundingClientRect();
        }
        this.options = options;
        if (e && e.preventDefault) e.preventDefault();
        if (!this._PopupDiv) {
            this.createPopup();
            if (options.zIndex) this._back.style.zIndex = options.zIndex;
            let opt = '';
            for (let i = 0; i < list.length; i++) {
                const el = list[i];
                opt += `<option value="${el.value}" ${el.value === value ? 'selected' : ''}>${el.name}</option>`;
            }
            this._PopupDiv.innerHTML = `
                <label style="font-size: 80%;">${title}</label>
                <select name="select" id="inp">${opt}</select>
                ${this._btnBlock}
            `;
            const input = this._PopupDiv.querySelector('select');
            this.btnOk = this._PopupDiv.querySelector('#btnOk');
            this.btnCancel = this._PopupDiv.querySelector('#btnCancel');

            document.addEventListener('keydown', this.global, false);

            if (options.showFocus) {
                this._oldBorder = options.element.style.border;
                options.element.style.border = 'blue 1px solid';
            }

            this.btnOk.onclick = (event) => {
                if (event) event.stopPropagation();
                document.removeEventListener('keydown', this.global, false);
                if (callback) {
                    callback(input.value);
                }
                this.close();
            };

            this.btnCancel.onclick = this._back.onclick = (event) => {
                this._cancel(event);
            };

            this._back.appendChild(this._PopupDiv);
            if (options.toBody) {
                this._main = document.body.appendChild(this._back);
            } else {
                this._main.appendChild(this._back);
                if (box) {
                    const boxShift = this._back.getBoundingClientRect();
                    box = {
                        left: box.left - boxShift.left,
                        top: box.top - boxShift.top,
                        height: box.height,
                        width: box.width,
                        bottom: box.bottom - boxShift.top
                    }
                }
            }

            input.focus();
        }

        this._Show(box);
    }

    inputBoxCustom(e, html, value, callback, options) {
        let box;
        if (!options) {
            options = { toBody: false, alignToElement: false }
        } else if (options.alignToElement) {
            box = options.element.getBoundingClientRect();
        }
        this.options = options;
        if (e && e.preventDefault) e.preventDefault();
        if (!this._PopupDiv && !options.msPopup) {
            this.createPopup();
            if (options.zIndex) this._back.style.zIndex = options.zIndex;
            this._PopupDiv.innerHTML = `<div id="inputbody">${html}</div>${this._btnBlock}`;
            const input = this._PopupDiv.querySelector('[id="inputbody"]');
            if (options.afterInit) {
                options.afterInit(input);
            }
            this.btnOk = this._PopupDiv.querySelector('#btnOk');
            this.btnCancel = this._PopupDiv.querySelector('#btnCancel');

            document.addEventListener('keydown', this.global, false);

            if (options.showFocus) {
                this._oldBorder = options.element.style.border;
                options.element.style.border = 'blue 1px solid';
            }

            this.btnOk.onclick = (event) => {
                if (event) event.stopPropagation();
                document.removeEventListener('keydown', this.global, false);
                if (callback) {
                    callback(input);
                }
                if (this._PopupDiv && this._PopupDiv.close) this._PopupDiv.close();
                this.close();
            };

            this.btnCancel.onclick = this._back.onclick = (event) => {
                this._cancel(event);
            };

            this._back.appendChild(this._PopupDiv);
            if (options.toBody) {
                this._main = document.body.appendChild(this._back);
            } else {
                this._main.appendChild(this._back);
                if (box) {
                    const boxShift = this._back.getBoundingClientRect();
                    box = {
                        left: box.left - boxShift.left,
                        top: box.top - boxShift.top,
                        height: box.height,
                        width: box.width,
                        bottom: box.bottom - boxShift.top
                    }
                }
            }

            input.focus();
            this._Show(box);
        } else {
            const popup = new MSPopUpWindow();
            popup.scale = options.scale || 1;
            popup.dragable = true;
            popup.modal = false;
            popup.title = options.title ? options.title : 'Введите информацию';
            popup.height = this.Height;
            popup.width = this.Width;
            popup.minimized = false;
            popup.mini = false;
            popup.closable = true;
            popup.resize = false;
            popup.boundsrestricted = true;
            popup.sizetocontent = 0;
            popup.offsetx = 0;
            popup.offsety = 0;
            popup.isenabled = true;
            popup.isvisible = false;
            popup.innerHTML = `<div id="inputbody">${html}</div>${this._btnBlock}`
            if (options.afterInit) {
                options.afterInit(popup.querySelector("#inputbody"));
            }
            $WinService.addWindow(popup);
            if (options.element) {
                const r = sessionStorage.getItem(`input_${options.element.nodeName}_${options.element.id}_state`);
                if (r) {
                    try {
                        const tl = JSON.parse(r);
                        popup._popup.style.top = tl.top,
                            popup._popup.style.left = tl.left
                    } catch (error) {

                    }
                }
            }
            popup.querySelector('#btnOk').onclick = e => {
                e.preventDefault();
                popup.querySelector('#btnOk').onclick = null;
                popup.isvisible = false;
                if (callback) {
                    if (options.element) {
                        const s = {
                            top: popup._popup.style.top,
                            left: popup._popup.style.left
                        }
                        sessionStorage.setItem(`input_${options.element.nodeName}_${options.element.id}_state`, JSON.stringify(s));
                    }
                    callback(popup.querySelector('[id="inputbody"]'));
                }
                popup.remove();
                $WinService.removeWindow(popup);
            }
            if (options.onCancel) {
                popup.onclose = options.onCancel;
            }

            popup.querySelector('#btnCancel').onclick = e => {
                if (popup.onclose) {
                    popup.onclose();
                }
                $WinService.removeWindow(popup);
            }
            popup.isvisible = true;
            popup._upWindow();
            this._msPopUp = popup;
        }
    }

    _Show(box, el) {
        const pDiv = el || this._PopupDiv;
        if (box) {
            pDiv.style.marginTop = 0;
            const rect = pDiv.getBoundingClientRect();
            if (box.top - rect.height < 0) {
                pDiv.style.top = `${box.bottom}px`
            } else {
                pDiv.style.top = `${box.top - rect.height}px`;
            }
            if (box.left + rect.width > window.innerWidth) {
                pDiv.style.left = `${window.innerWidth - box.width}px`
            } else {
                pDiv.style.left = `${box.left}px`;
            }
        }
        if (this._PopupDiv) this._PopupDiv.style.display = 'flex';
    }
    createPopup() {
        const style = document.createElement('style');
        style.innerHTML = `
        #divCancel div {
            display:flex;
        }
        .PopupDiv {
            box-shadow: rgba(35, 39, 76, 0.5) 0px 3px 10px;
            position: absolute;
            padding: 12px;
            z-index: 2;
            flex-direction: column;
            align-self: center;
            margin-top: 0px;
            background: ghostwhite;
            display: flex;
            border: 1px #8C8C8C solid;
            color: #8C8C8C;
        }
        span {
            font-size: 12px; 
        }
        div.inp {
            padding-top: 5px;
            height: 20px;
        }
        .hmi-j-close:before {
            content: "\\e91e";
        }
        .bgimg {
            border: 1px solid;
            font-size: 19px;
            width: 20px;
            height: 18px;
            border-left: 0;
        }
        .bgimg:hover {
            background-color: #00000021;
        }`;
        this._back = document.createElement('div');
        this._back.id = 'divCancel';
        this._back.style.position = 'absolute';
        this._back.style.display = 'flex';
        this._back.style.flexDirection = 'column';
        this._back.style.top = '0';
        this._back.style.left = '0';
        this._back.style.bottom = '0';
        this._back.style.right = '0';
        this._back.style.zIndex = '900';
        this._back.appendChild(style);

        this._PopupDiv = document.createElement('div');
        this._PopupDiv.classList.add('PopupDiv');
    }

    _cancel(ev) {
        if (ev) {
            ev.stopPropagation();
            if (ev.target.id != 'divCancel' && ev.target.id != 'btnCancel' && ev.keyCode != 27) { return; }
        }
        this.close();
        return false;
    }

    close() {
        if (this._msPopUp) {
            $WinService.removeWindow(this._msPopUp);
            return;
        }
        if (this.options.showFocus) {
            this.options.element.style.border = this._oldBorder;
        }
        document.removeEventListener('keydown', this.global, false);
        if (this._PopupDiv && this._PopupDiv.close) this._PopupDiv.close();
        delete this._PopupDiv;
        if (!this._back) return;
        this._back.remove();
        this._back = null;
    }
}